import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { currentDate } from '../../../utils/date';
import { ProfileContext } from '../../Contexts/contexts';

function Header() {
	const contextData = useContext(ProfileContext);

	if (contextData && contextData.isClient) {
		return (
			<>
				<Link to="/" className="logo-redirection">
					<div className="logo"></div>
				</Link>
				<div className="infos-user">
					<div>
						<div>
							<h1 className="header-title">
								Hello {contextData.client.firstName} 👋
							</h1>
							<div className="content">Let's start something new today</div>
						</div>
					</div>
					<div className="current-date">{currentDate}</div>
				</div>
			</>
		);
	} else {
		return (
			<>
				<div className="logo"></div>
				<div className="infos-user">
					<div>
						<div>
							<h1 className="header-title">
								Hello {contextData.expert.firstName} 👋
							</h1>
							<div className="content">Votre expert, Vos critères</div>
						</div>
					</div>
					<div className="current-date">{currentDate}</div>
				</div>
			</>
		);
	}
}

export default Header;
